module.exports = [
	{
		"componentChunkName": "page-component---src-pages-404-jsx",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "page-component---src-pages-about-jsx",
		"jsonName": "about.json",
		"path": "/about/"
	},
	{
		"componentChunkName": "page-component---src-pages-contact-jsx",
		"jsonName": "contact.json",
		"path": "/contact/"
	},
	{
		"componentChunkName": "page-component---src-pages-index-jsx",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-jsx",
		"jsonName": "404-html.json",
		"path": "/404.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 15178676390636814000